const incompleteMessage =
  'Are you sure you want to mark these steps incomplete and the appointment unfinished? There are multiple steps that are still pending, and if you leave the appointment incomplete, the steps on the progress bar will remain active, showing their true progress without any manual overrides!';

const completeMessage =
  'Are you sure you want to mark these steps completed and appointment completed? There are multiple steps that are not finished and if you complete the appointment all the steps on the progress bar will be marked grey as they were manually overridden!';

export default { completeMessage, incompleteMessage };
